/*Состояния*/
const state = () => ({
  news: [],
  currentNews: [],
  message: {},
  newsPagination: {},
});
export { state };
